<template>
    <div>
        <van-nav-bar title="失物发布" left-text="返回" left-arrow @click-left="onClickLeft" />
        <!-- 物品 -->
        <van-field readonly clickable name="picker" :value="value" label="种类" placeholder="请选择种类"
            @click="showPicker = true" style="margin-top: 10px;" />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
        <!-- 地区 -->
        <van-field readonly clickable name="picker" :value="values" label="拾到地区" placeholder="点击选择校区"
            @click="showArea = true" />
        <van-popup v-model="showArea" position="bottom">
            <van-picker show-toolbar :columns="areaList" @confirm="onConfirmb" @cancel="showArea = false" />
        </van-popup>
        <!-- 详细地点 -->
        <wd-input v-model="value1" placeholder="请填写详细地点" label="详细拾到地点(选填)"></wd-input>
        <!-- 拾到时间 -->
        <wd-datetime-picker type="date" v-model="value2" label="拾到时间"></wd-datetime-picker>
        <!-- 联系电话 -->
        <wd-input v-model="value3" placeholder="请输入联系电话" label="联系电话"></wd-input>
        <!-- 发布者姓名 -->
        <wd-input v-model="value4" placeholder="请输入发布者姓名" label="发布者姓名"></wd-input>
        <!-- 丢失者姓名 -->
        <wd-input v-model="value5" placeholder="请输入丢失者姓名" label="丢失者姓名"></wd-input>
        <!-- 上传照片 -->
        <div
            style="text-align: left;border-top: 0.1px solid grey; padding-top: 10px; background-color: #fff; position: relative;">
            <h3>上传照片</h3>
            <span style="position: absolute; right: 0; top: 30px;">无照片禁止上传！！</span>
            <wd-upload v-model="fileList" multiple action="https://jsonplaceholder.typicode.com/posts/"></wd-upload>
        </div>
        <!-- 详情 -->
        <div style="border-top: 0.1px solid grey;  background-color: #fff;">
            <h4 style="display: inline-block;">详情描述</h4>
            <wd-input type="textarea" v-model="value6" rows="6" maxlength="10" clearable show-word-limit
                placeholder="请输入详情描述"></wd-input>
        </div>
        <!-- 提交 -->
        <wd-button type="warning" block style="margin-top: 5px;" @click="submitItem">提交</wd-button>
    </div>
</template>

<script>
export default {
    name: 'Shiwu',
    data() {
        return {
            value: '',
            values: '',
            value1: '',
            value2: '',
            value3: '',
            value4: '',
            value5: '',
            value6: '',
            columns: ['证件', '钥匙', '钱包', '卡', '手机', '包', '笔记本', '宠物', '衣服', '其他'],
            showPicker: false,
            showArea: false,
            areaList: ['增城校区', '沙太校区',],
            fileList: [{
                name: '图片名称',
                url: 'https://img0.baidu.com/it/u=872626013,2257756031&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
            }],
        }
    },
    methods: {
        onClickLeft() {
            this.$router.push('/');
        },
        onConfirm(value) {
            this.value = value;
            this.showPicker = false;
        },
        onConfirmb(values) {
            this.values = values;
            this.showArea = false;
        },
        submitItem() {
            const item = {
                type: this.value,  // 物品类型
                area: this.values,  // 地区
                details: this.value6,  // 详细描述
                image: this.fileList.length > 0 ? this.fileList[0].url : '' // 图片链接
            };
            this.$store.dispatch('addItem', item);
            this.$router.push('/Hall');  // 可选，跳转到展示列表的页面
        }
    },
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Shiwu.vue